import { create } from "zustand";
import { Product, ProductFilters } from "../models/product";

interface ProductStore {
  filters: ProductFilters;
  selectedProduct: Product | null;
  setFilters: (filters: Partial<ProductFilters>) => void;
  resetFilters: () => void;
  setSelectedProduct: (product: Product | null) => void;
}

const initialFilters: ProductFilters = {
  page: 1,
  limit: 10,
  sort: 'latest',
};

export const useProductStore = create<ProductStore>((set) => ({
  filters: initialFilters,
  selectedProduct: null,
  setFilters: (newFilters) =>
    set((state) => ({
      filters: { ...state.filters, ...newFilters },
    })),
  resetFilters: () => set({ filters: initialFilters }),
  setSelectedProduct: (product) => set({ selectedProduct: product }),
})); 